// This file is auto-generated by @hey-api/openapi-ts



/**
 * Endpunktpfad: /reco/pythia/kombi-modul/render/outfits
 */

export const ENDPOINT_PATH_RECO_PYTHIA_KOMBI_MODUL_RENDER_OUTFITS: string = "/reco/pythia/kombi-modul/render/outfits";

/**
 * Endpunktpfad: /reco/pythia/kombi-modul/render/bestandteile
 */

export const ENDPOINT_PATH_RECO_PYTHIA_KOMBI_MODUL_RENDER_BESTANDTEILE: string = "/reco/pythia/kombi-modul/render/bestandteile";

/**
 * Endpunktpfad: /reco/pythia/kombi-modul/render/app/bestandteile
 */

export const ENDPOINT_PATH_RECO_PYTHIA_KOMBI_MODUL_RENDER_APP_BESTANDTEILE: string = "/reco/pythia/kombi-modul/render/app/bestandteile";
